export default __webpack_public_path__ + "_/_/_/node_modules/tinymce/skins/ui/oxide-dark/skin.shadowdom.css";